import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M20 7.58v8.84c0 1.565-1.716 2.524-3.048 1.704l-7.184-4.42a2 2 0 0 1 0-3.407l7.184-4.421C18.284 5.056 20 6.014 20 7.579M4 7a2 2 0 1 1 4 0v10a2 2 0 1 1-4 0z"
    }
  )
);
var SvgSkipPreviousFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SkipPreviousFilled_default = SvgSkipPreviousFilled;

export { SkipPreviousFilled_default as default };
